import {isObject, isString} from 'lodash';
import React, {useCallback} from 'react';

function SelectValue(props) {
    const {operator, value, onChange} = props;

    const handleChange = useCallback(event => onChange(event.target.value), [onChange]);

    return (
        <select className="form-control" value={value} onChange={handleChange}>
            <option value=""></option>
            {operator.values.map((value, i) => {
                if (isObject(value)) {
                    return (
                        <option value={value.value} key={i}>
                            {value.label ?? value.value}
                        </option>
                    );
                } else if (isString(value)) {
                    return (
                        <option value={value} key={i}>
                            {value}
                        </option>
                    );
                }
            })}
        </select>
    );
}

export default SelectValue;
